
import { Component, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import CrudLayout from "@/layouts/CrudLayout.vue";
import Validation from "@/components/Validation.vue";
import CatalogForm from "@/views/admin/catalog/CatalogForm.vue";

const namespace: string = "catalog";

@Component({
  components: {
    CrudLayout,
    Validation,
    CatalogForm
  }
})
export default class CatalogUpdate extends Vue {
  public name: string = "CatalogUpdate";
  private resourceName = "catalog";

  @Getter("getError", { namespace }) error: any;
  @Getter("isLoading", { namespace }) loading: any;
  @Getter("isUpdated", { namespace }) updated: any;
  @Getter("getItem", { namespace }) item: any;

  @Action("update", { namespace }) updateItemAction: any;
  @Action("findOne", { namespace }) getItemAction: any;
  @Action("resetUpdate", { namespace }) resetAction: any;

  protected back() {
    // TODO remember last table state (session storage)
    this.$router.push({ path: "/" + this.resourceName });
  }

  mounted() {
    const id: number = Number.parseInt(this.$route.params.id);

    this.getItemAction({
      resource: this.resourceName,
      id: id,
      descriptionField: "name"
    });
  }

  beforeDestroy() {
    this.resetAction();
  }
}
